import firebase_api from '@/firebase/firebase_api'

const object = {
    data: {
        role: "",
        pseudo: "",
        email:"",
        id: null,
        nom: "",
        prenom:"",
        adresse:"",
        tel:"",
        licence:"",
        isLicencie:false,
        admin: false,
        elo: 1199,
        customs: {}
        
    },
    tournoi: {        
        pseudo: "",
        id: "",
        role: "player",
        nom: "",
        prenom:"",
        elo: 1199,
        email: ""
    },
    tournoiForme: {        
        pseudo: "",
        id: "",
        role: "player",
        coequipier1 : null,
        coequipier2 : null,
        meneur: false,
        nom: "",
        prenom:"",
        email: ""
    },
    addCoequipier(club, tournoi, joueur, coequipier, Jx) {
        var numeroADD = tournoi.joueurs.length;
        var numeroCaptain = joueur.numero;
        var joueurInEquipe = {
            numero: numeroADD,
            error: 0,
            errorDetail: [],
            parties: []
        }
        if (Jx=='J2') {
            tournoi.joueurs[numeroADD] = coequipier;
            tournoi.options.joueurs[numeroADD] = coequipier;
            tournoi.joueurs[numeroCaptain].coequipier1 = coequipier.id;
            tournoi.options.joueurs[numeroCaptain].coequipier1 = coequipier.id;
        }
        else if (Jx == 'J3') {
            tournoi.joueurs[numeroADD] = coequipier;
            tournoi.options.joueurs[numeroADD] = coequipier;
            tournoi.joueurs[numeroCaptain].coequipier2 = coequipier.id;
            tournoi.options.joueurs[numeroCaptain].coequipier2 = coequipier.id;
        }
        firebase_api.api.getDb().collection("club").doc(club.id)
        .collection("tournois").doc(tournoi.id).update({
            joueurs: tournoi.joueurs, 
            options: tournoi.options
        })

        firebase_api.api.getDb().collection("club").doc(club.id)
            .collection("tournois").doc(tournoi.id).collection("parties").get()
            .then(parties=>{
                for (var indexPartie in parties.docs) {
                var docPartie = parties.docs[indexPartie];
                    docPartie.ref.collection("equipes").where("joueurs.J1.numero", "==", parseInt(numeroCaptain)).get().then(equipeDocs=>{
                        
                        if (equipeDocs.docs.length == 1) {
                            var equipeData = equipeDocs.docs[0].data();
                            var joueurData = equipeData.joueurs;
                            joueurData[Jx] = joueurInEquipe;
                            var equipeRef = equipeDocs.docs[0].ref;
                            equipeRef.update({
                                'joueurs' : joueurData
                            })
                        }
                    })
                    docPartie.ref.collection("equipes").where("contre.J1.numero", "==", parseInt(numeroCaptain)).get().then(equipeDocs=>{
                        if (equipeDocs.docs.length == 1) {
                            var equipeData = equipeDocs.docs[0].data();
                            var joueurData = equipeData.contre;
                            joueurData[Jx] = joueurInEquipe;
                            var equipeRef = equipeDocs.docs[0].ref;
                            equipeRef.update({
                                'contre' : joueurData
                            })
                        }
                    })
                }
            })
    },
    supCoequipier(club, tournoi, numeroCaptain, Jx, numeroSup) {
       
        firebase_api.api.getDb().collection("club").doc(club.id)
            .collection("tournois").doc(tournoi.id).collection("parties").get()
            .then(parties=>{
                for (var indexPartie in parties.docs) {
                var docPartie = parties.docs[indexPartie];
                    docPartie.ref.collection("equipes").where("joueurs.J1.numero", "==", parseInt(numeroCaptain)).get().then(equipeDocs=>{
                        
                        if (equipeDocs.docs.length == 1) {
                            var equipeData = equipeDocs.docs[0].data();
                            var joueurData = equipeData.joueurs;
                           
                            joueurData[Jx] = null;
                            var equipeRef = equipeDocs.docs[0].ref;
                            equipeRef.update({
                                'joueurs' : joueurData
                            })
                        }
                    })
                    docPartie.ref.collection("equipes").where("contre.J1.numero", "==", parseInt(numeroCaptain)).get().then(equipeDocs=>{
                        if (equipeDocs.docs.length == 1) {
                            var equipeData = equipeDocs.docs[0].data();
                            var joueurData = equipeData.contre;
                           
                            joueurData[Jx] = null;
                            var equipeRef = equipeDocs.docs[0].ref;
                            equipeRef.update({
                                'contre' : joueurData
                            })
                        }
                    })
                }
            })
            if (Jx=='J2') {
                tournoi.joueurs[numeroCaptain].coequipier1 = null;
                tournoi.options.joueurs[numeroCaptain].coequipier1 = null;
            }
            else if (Jx=='J3') {
                tournoi.joueurs[numeroCaptain].coequipier2 = null;
                tournoi.options.joueurs[numeroCaptain].coequipier2 = null;
            }
            tournoi.joueurs[numeroSup].id = 'NaN';
            tournoi.options.joueurs[numeroSup].id = 'NaN';
           
            firebase_api.api.getDb().collection("club").doc(club.id)
            .collection("tournois").doc(tournoi.id).update({
                joueurs: tournoi.joueurs, 
                options: tournoi.options
            })
    },
    verifEmail(email) {
        var error = email != "";
        if (error) {
          
           var emailCheck=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
           
           //error = !email.match(reEmail);
           error = emailCheck.test(email);
          
        }
        return error;
     },
    calculPseudo(joueur) {
        var pseudo = joueur.pseudo;
       if (typeof(joueur.pseudo) == 'undefined' || joueur.pseudo =='') {
          if (joueur.nom!='') {
          pseudo = joueur.nom.substr(0,7).toUpperCase();
          if (joueur.prenom!='')
              pseudo += "." + joueur.prenom.substr(0,3).toUpperCase();
          else
               pseudo += joueur.nom.substr(8,3).toUpperCase();
          }
          else {
              if (joueur.prenom!='')
                pseudo += joueur.prenom.substr(0,11).toUpperCase();
              else 
                pseudo = ""
          }
      }
      return pseudo;
    },
    search (joueur, filters) {
        var searchReturn = true;
      
        for (var customId in filters) {
            if (searchReturn) {
                var filter = filters[customId];
                if (filter.valuesDefault == null || filter.valuesDefault.length==0)
                    searchReturn = true;
                else
                    if (typeof(joueur.customs)!="undefined") {
                        if (typeof(joueur.customs[customId]) != "undefined") {
                            if (searchReturn)    {
                                if (filter.type == 'radio' && searchReturn) {
                                    
                                    searchReturn = joueur.customs[customId] ==  filter.valuesDefault;
                                   
                                }
                                if (filter.type == 'checkbox'  && searchReturn) {
                                    filter.valuesDefault.forEach(valueCustom=>{
                                        if (searchReturn) {
                                            var indexFind = joueur.customs[customId].indexOf(valueCustom);
                                            searchReturn = indexFind == -1;
                                        }
                                    })
                                }
                                if (searchReturn) {
                                    var valueFilter =  filter.valuesDefault;
                                    var valueJoueur = joueur.customs[customId];
                                    if (filter.type == 'date') {
                                        valueFilter = new Date ( filter.valuesDefault);
                                        valueJoueur = new Date (joueur.customs[customId]);
                                    }
                                    if (filter.operator == "=") {
                                        searchReturn = filter.valuesDefault == joueur.customs[customId];
                                    }
                                    if (filter.operator == ">")
                                        searchReturn = valueJoueur > valueFilter;
                                    if (filter.operator == "<")
                                        searchReturn = valueJoueur < valueFilter;
                                }
                            }
                        }
                        else
                            searchReturn = false;
                    }
                    else
                        searchReturn = false;
            }
            else
                break;
        }
       
        return searchReturn;

    },
    set(club, joueur, fct) {
        firebase_api.api.getDb().collection("club").doc(club.id).collection("joueurs").doc(joueur.id).set(
            joueur
        );
    },
    delete (club, joueur, fct) {
       
        firebase_api.api.getDb().collection("club").doc(club.id).collection("joueurs").doc(joueur.id).delete()
            .then(()=>{
                
                if (joueur.userId != null) {
                   
                    firebase_api.api.getDb().collection("user").doc(joueur.userId).get().then(user=>{
                      
                        var clubs = user.data().clubs;
                      
                        var indexOf = clubs.findIndex(clubItem=>clubItem.idClub===club.id);
                    
                        if (indexOf != -1) {
                            clubs.splice(indexOf, 1);
                         
                            user.ref.update({
                                clubs: clubs
                            }).then(()=>{
                              
                                fct();
                            })
                        }
                        else  
                            fct();
                            
                    })
                }
                else
                    fct()
            })
    }
}


export default {
	object: object
}